<template>
  <div class="research_5">
    <v-container>
      <v-row class="mt-4" justify="center">
        <v-col cols="10" xl="8">
          <div class="heading text-h6 text-sm-h4 font-weight-bold pl-4">
            認知機能の低下に起因する自動車事故の抑止を目的としたマルチモーダル認知症セルフチェックシステムに関する研究
          </div>
        </v-col>
        <v-col cols="9" xl="7">
          <div>
            <div>助成：日本損害保険協会 2025年度 自賠責運用益拠出事業</div>
          </div>
        </v-col>
      </v-row>

      <v-row class="my-4" justify="center">
        <v-col cols="9" lg="8" xl="5">
          <a>
            <v-img @click="clickImage(require(`@/assets/research/R5_research.png`))"
            :src="require(`@/assets/research/R5_research.png`)"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "R5",
  methods: {
    clickImage: function (image) {
      window.open(image);
    }
  }
}
</script>
<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
</style>
